<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="ID" v-if="id">
          <b-input placeholder="ID" disabled v-model="model.id"></b-input>
        </b-field>
        <b-field
          label="Значение"
          :type="{'is-danger': errors.has('name')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('value', 'required')
          }]">
          <b-input
            name="value"
            placeholder="Значение"
            icon="user"
            v-validate="'required'"
            v-model="model.value"
            :disabled="true">
          </b-input>
        </b-field>
        <b-field
          label="Описание"
          :type="{'is-danger': errors.has('name')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('description', 'required')
          }]">
          <b-input
            name="description"
            placeholder="Описание полномочия"
            icon="pen"
            v-validate="'required'"
            v-model="model.description">
          </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Сохранить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>

<script>

import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    events: '',
});

import { EventBus } from '@/utils'

export default {
  name: 'PermissionForm',
  components: {
    //
  },
  props: {
    id: Number,
    title: String
  },
  data: function () {
    return {
      model: {
        id: undefined,
        name: '',
        is_active: false
      }
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this

    if ($this.id){
      this.$store.dispatch('getPermission', $this.id)
        .then(response => {
          let data = response.data.data;
          $this.model = data
        })
        .catch(error => {
          this.model = this.purge_model
        })
    }
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          $this.doUpdate()
          return;
        }
        this.$toast.open({
          message: $this.$i18n.t('notify.form_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      });
    },
    doUpdate () {
      let $this = this
      if ($this.id){
        $this.$store.dispatch('updatePermission', $this.model)
      }
      else{
        $this.$store.dispatch('createPermission', $this.model)
      }
    }
    
  }
}
</script>

<style scoped>
</style>
<style>
</style>